<div >
  <div>
    <!-- Optinal sightseeing section -->
    <div class="ion-no-padding my-1">
      <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between">
        <ion-title class="dark-title-sm ion-no-padding">Transfers</ion-title>
        <div>
          <div class="currency-container position-relative">
            <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle" [(ngModel)]="formEnabled" (ngModelChange)="formToggleChanged()"></ion-toggle>
            <p class="toggle-tooltip" [ngClass]="formEnabled ? 'green': 'red'">{{formEnabled ? 'This section will be displayed in the package.' : 'This section will not be displayed in the package.'}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="ion-padding-horizontal" *ngIf="formEnabled">
      <form [formGroup]="transfersForm">
        <div formArrayName="transfersDetails">
          <div *ngFor="let transfer of getTransfersFormArray().controls; index as transferIndex" [formGroupName]="transferIndex">
            <div class="transfer-main-container">
              <div class="d-flex justify-content-between align-items-center">
                <div class="details-container">
                  <div>
                    <div class="input-grid">
                      <div>
                        <p class="label">Pax Count*</p>
                      </div>
                      <div formGroupName="paxRange">
                        <div class="d-flex align-items-center">
                          <div [ngClass]="{ 'invalid-input': checkInvalidControl(transfer, 'paxRange.minRange') || checkInvalidControl(transfer, 'paxRange') }">
                            <input appNumbersOnly type="text" class="pax-input input text-center" placeholder="0" [appMaxLength]="4" formControlName="minRange">
                          </div>
                          <p class="mb-0 mx-1">-</p>
                          <div [ngClass]="{ 'invalid-input': checkInvalidControl(transfer, 'paxRange.maxRange') || checkInvalidControl(transfer, 'paxRange') }">
                            <input appNumbersOnly type="text" class="pax-input input text-center" placeholder="0" [appMaxLength]="4" formControlName="maxRange">
                          </div>
                        </div>
                      </div>
                      <div>
                        <p class="label">Vehicle Type*</p>
                      </div>
                      <div class="mb-1">
                        <div [ngClass]="{ 'invalid-input': checkInvalidControl(transfer, 'vehicleType') }">
                          <input type="text" class="input" placeholder="Ex - Mini Bus" formControlName="vehicleType">
                        </div>
                      </div>

                      <div>
                        <p class="label">Note</p>
                      </div>
                      <div>
                        <div [ngClass]="{ 'invalid-input': checkInvalidControl(transfer, 'note') }">
                          <app-text-formatting-input formControlName="note"></app-text-formatting-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="image-container">
                  <div class="upload-container" *ngIf="!getTransfersFormArray().at(transferIndex).get('imageDoc')?.value">
                    <label class="upload-btn" [attr.for]="'transferImage' + transferIndex">Upload Image <ion-icon class="icon align-middle" name="camera-outline"></ion-icon></label>
                  </div>

                  <div class="uploaded-image-container w-100" *ngIf="getTransfersFormArray().at(transferIndex).get('imageDoc')?.value">
                    <img [src]="getImgUrl(getTransfersFormArray().at(transferIndex).get('imageDoc')?.value)" alt="" class="uploaded-img w-100">
                    <div class="d-flex justify-content-end align-items-center">
                      <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger" (click)="removeTransfersImage(transferIndex)">
                        <ion-icon name="close-outline"></ion-icon> Remove Image
                      </ion-button>
                      <label [attr.for]="'transferImage' + transferIndex"  class="reupload-btn">
                          <ion-icon name="cloud-upload-outline"></ion-icon> <span class="ms-1">Reupload</span>
                      </label>
                      <!-- <ion-button class="sm-clear-btn" fill="clear" size="small" color="medium" >
                        <ion-icon name="add-outline"></ion-icon> Reupload
                      </ion-button> -->
                    </div>
                  </div>

                  <input type="file" [attr.id]="'transferImage' + transferIndex" class="d-none" (change)="transferImageSelected($event, transferIndex)" accept=".png, .jpg, .jpeg">
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <ion-button class="sm-clear-btn" fill="clear" size="small" color="danger" (click)="removeTransfers(transferIndex)" *ngIf="getTransfersFormArray().length > 1">
                <ion-icon name="trash-outline"></ion-icon> Remove Transfer
              </ion-button>
              <ion-button class="sm-clear-btn" fill="clear" size="small" color="medium" (click)="addTransfers()">
                <ion-icon name="add-outline"></ion-icon> Add Transfer
              </ion-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>